import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Confirm from 'semantic-ui-react/dist/commonjs/addons/Confirm'
import Form from 'semantic-ui-react/dist/commonjs/collections/Form'
import Icon from 'semantic-ui-react/dist/commonjs/elements/Icon'
import Input from 'semantic-ui-react/dist/commonjs/elements/Input'
import Modal from 'semantic-ui-react/dist/commonjs/modules/Modal'
import Select from 'semantic-ui-react/dist/commonjs/addons/Select'
import { connect } from 'react-redux'

class HeatPressNameForm extends Component {
  state = {
    isConfirmDeleteOpen: false,
  }

  handleTextChange = (e, { value }) => {
    const { handleChange, name } = this.props
    handleChange({
      ...name,
      text: value,
    })
  }

  handleLocationChange = (e, { value }) => {
    const { handleChange, name } = this.props
    handleChange({
      ...name,
      location: value,
    })
  }

  handleSizeChange = (e, { value }) => {
    const { handleChange, name } = this.props
    handleChange({
      ...name,
      size: value,
    })
  }

  handleColourChange = (e, { value }) => {
    const { handleChange, name } = this.props
    handleChange({
      ...name,
      color: value,
    })
  }

  handleCloseConfirmDelete = () => this.setState({ isConfirmDeleteOpen: false })

  handleOpenConfirmDelete = () => this.setState({ isConfirmDeleteOpen: true })

  handleDelete = () => {
    const { handleDelete, name } = this.props
    handleDelete(name)
  }

  render() {
    const { name: n, heatColorOptions, heatLocationOptions, heatSizeOptions } = this.props
    const { isConfirmDeleteOpen } = this.state

    return (
      <div>
        <Form.Group key={n.id}>
          <Form.Field
            control={Input}
            fluid
            onChange={this.handleTextChange}
            placeholder="Text"
            value={n.text || ''}
            width={5}
          />
          <Form.Field
            control={Select}
            fluid
            onChange={this.handleLocationChange}
            options={heatLocationOptions
              .filter(o => o.value.trim().length > 0)
              .map(o => ({
                key: o.value,
                text: o.value,
                value: o.value,
              })
            )}
            placeholder="Location"
            value={n.location}
            width={5}
          />
          <Form.Field
            control={Select}
            fluid
            onChange={this.handleSizeChange}
            options={heatSizeOptions
              .filter(o => o.value.trim().length > 0)
              .map(o => ({
                key: o.value,
                text: o.value,
                value: o.value,
              })
            )}
            placeholder="Size"
            value={n.size}
            width={2}
          />
          <Form.Field
            control={Select}
            fluid
            onChange={this.handleColourChange}
            options={heatColorOptions
              .filter(o => o.value.trim().length > 0)
              .map(o => ({
                key: o.value,
                text: o.value,
                value: o.value,
              })
            )}
            placeholder="Colour"
            value={n.color}
            width={3}
          />
          <Form.Field
            style={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
            width={1}
          >
            <Icon
              color="red"
              name="delete"
              onClick={this.handleOpenConfirmDelete}
              size="large"
              style={{ cursor: 'pointer' }}
            />
          </Form.Field>
        </Form.Group>
        <Confirm
          content={(
            <Modal.Content>
              <span>Are you sure you want to delete the heat press name item <strong>{n.text}</strong>?</span>
            </Modal.Content>
          )}
          header="Confirm delete heat press name item"
          onCancel={this.handleCloseConfirmDelete}
          onConfirm={this.handleDelete}
          open={isConfirmDeleteOpen}
        />
      </div>
    )
  }
}

HeatPressNameForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  name: PropTypes.object.isRequired,

  // The following props from redux:
  heatColorOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  heatLocationOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  heatSizeOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
}

const mapState = state => ({
  heatColorOptions: state.app.hpEmb.heatColorOptions,
  heatLocationOptions: state.app.hpEmb.heatLocationOptions,
  heatSizeOptions: state.app.hpEmb.heatSizeOptions,
})

export default connect(mapState)(HeatPressNameForm)
